<!-- Hide navigation when mobile keyboard is visible to prevent jumping -->
<div
  class="w-full grid grid-cols-[1fr_minmax(80px,_38.75rem)_1fr] pt-2 pb-2"
  [class.hidden]="isKeyboardVisible"
>
  <div
    class="flex items-stretch w-full max-w-[38.75rem] col-start-2 justify-self-center md:px-2"
  >
    @if ((navigationStateService.hideBackButton$ | async) === false) {
      <div @slideInOut class="flex-shrink-0">
        <app-button
          buttonId="prev-btn"
          (buttonClick)="handlePreviousClick($event)"
          [description]="'navigation.back.button' | translate"
          [buttonTitle]="'navigation.back.button' | translate"
          customHostClasses="mr-4 w-[44px] aspect-square flex-shrink-0"
          customClasses="font-normal lg:hover:font-bold transition-transform-slow lg:hover:scale-[1.05] justify-center items-center border-primary border-solid w-[44px] h-[44px] flex-shrink-0"
          [disabled]="disablePrevious"
          [icon]="{
            iconType: icon,
            iconColor: 'primary',
            iconRotation: 180,
            iconWidth: 26,
            iconHeight: 24,
          }"
        >
        </app-button>
      </div>
    }

    @if (validationErrorCount && validationErrorCount > 0) {
      <app-button
        buttonId="validation-errors-btn"
        (buttonClick)="goToValidationClick()"
        customHostClasses="w-full"
        [buttonText]="
          'navigation.adjusterror.button'
            | translate: { count: validationErrorCount }
        "
        elementType="anchor"
        customClasses="flex items-center justify-center gap-2 w-full h-[44px] uppercase text-sm md:text-xl lg:text-2xl font-normal lg:hover:font-bold underline lg:hover:scale-y-[1.02] lg:hover:scale-x-[1.005]"
        [icon]="{
          placement: 'right',
          iconType: icon,
          iconWidth: 26,
          iconHeight: 24,
        }"
      ></app-button>
    } @else {
      <app-button
        buttonId="next-btn"
        (buttonClick)="handleNextClick()"
        form="survey-form"
        customHostClasses="w-full"
        [buttonText]="nextButtonText || 'navigation.next.button' | translate"
        [description]="
          disableNext
            ? ('navigation.next.buttondescription' | translate)
            : undefined
        "
        [disabled]="disableNext"
        [buttonType]="'submit'"
        customClasses="flex items-center justify-center w-full h-[44px] uppercase text-sm xs:text-xl font-normal lg:hover:font-bold lg:hover:scale-y-[1.02] lg:hover:scale-x-[1.02] transition-transform"
        [icon]="{
          placement: 'right',
          iconType: icon,
          iconWidth: 26,
          iconHeight: 24,
        }"
      ></app-button>
    }
  </div>
  <div
    class="col-start-3 hidden md:flex md:flex-col md:items-end md:justify-center pl-4"
  >
    <div>
      <div class="text-xs lg:text-sm">
        {{ "powered.by" | translate }}
      </div>
      <a
        href="https://www.questback.com"
        target="_blank"
        rel="noopener noreferrer"
        class="questback-icon block"
        aria-label="Questback"
      ></a>
    </div>
  </div>
</div>
